// src/integration/growth/iap.ts — in-app purchases (RevenueCat via @revenuecat/purchases-capacitor).
//
// Gated by isSurfaceLive('subscription') / isSurfaceLive('cosmeticIap'); native-only. RevenueCat fronts
// Play Billing / StoreKit behind entitlements (restore, refund webhooks, sandbox). The PUBLIC sdk key
// (goog_…/appl_…) is non-secret; the SECRET webhook key stays in Render env. No-op stub until installed.

import type { GrowthInitResult } from './types';

export async function initIap(): Promise<GrowthInitResult> {
  // ACTIVATION (when @revenuecat/purchases-capacitor@^8 [Capacitor 6] is installed + interlocks green):
  //   const { Purchases } = await import('@revenuecat/purchases-capacitor');
  //   await Purchases.configure({ apiKey: ADS_CONFIG.revenueCatPublicKey });
  //   return { active: true, reason: 'revenuecat configured' };
  return { active: false, reason: '@revenuecat/purchases-capacitor not installed (activation pending)' };
}

/** Whether the player currently holds the "infinite custom topics" subscription entitlement. */
export async function hasInfiniteTopics(): Promise<boolean> {
  // ACTIVATION: read RevenueCat customerInfo.entitlements.active['infinite_topics'].
  return false; // dark → no entitlement, custom-topic cap stays at its free default
}
